import { render, staticRenderFns } from "./AssetStateList.vue?vue&type=template&id=fb5ed522&scoped=true"
import script from "./AssetStateList.vue?vue&type=script&lang=js"
export * from "./AssetStateList.vue?vue&type=script&lang=js"
import style0 from "./AssetStateList.vue?vue&type=style&index=0&id=fb5ed522&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5ed522",
  null
  
)

export default component.exports